import axios from "axios"
// import { useSelector } from "react-redux"
import { store } from "../store"
import { CREATE_ESTADOS_ERROR, CREATE_ESTADOS_LOADING, CREATE_ESTADOS_SUCCESS, DELETE_ESTADOS_ERROR, DELETE_ESTADOS_LOADING, DELETE_ESTADOS_SUCCESS, GET_ESTADOS_ERROR, GET_ESTADOS_LOADING, GET_ESTADOS_SUCCESS, UPDATE_ESTADOS_ERROR, UPDATE_ESTADOS_LOADING, UPDATE_ESTADOS_SUCCESS } from "./estado_types"
import { BASE_URL } from "../../constants/config"
import { LOGOUT } from "../users/user_types"

import {toast , Toaster } from 'react-hot-toast';


export const getEstados = ()=>async(dispatch)=>{
    const {token} = store.getState().userReducer
    dispatch({type: GET_ESTADOS_LOADING})
    try {
        
        //console.log(" Inicio getEstados " );

        const res = await axios(BASE_URL+"/estado", {
            method: "get",
            headers: {
                Authorization: token
            }
        })                

        const {status, message, data} = res.data
        /*console.log(" RES Estado "+status+" => ",res.data);
        console.log(" RES Estado 2 "+status+" => ",dataestado);*/
        if(status === 1)
        dispatch({type: GET_ESTADOS_SUCCESS, payload: data})
        else if(status === 2)
        dispatch({type: LOGOUT})
        else {
            toast.error(" Error cargando Estados. "+message)
                dispatch({type: GET_ESTADOS_ERROR})
        }
    } catch (error) {
        toast.error("Error en la conexión");
        dispatch({type: GET_ESTADOS_ERROR})
    }
}

export const createEstados = (obj)=>async(dispatch)=>{
    
    
    const {token} = store.getState().userReducer
    dispatch({type: CREATE_ESTADOS_LOADING})
    try {
        
        const res = await axios(BASE_URL+"/estado/create", {
            method: "post",
            data: obj,
            headers: {
                Authorization: token
            }
        })
        const {status, message} = res.data

        console.log(status);
        if(status === 1)
        {
            toast.success(" Estado creado correctamente. ")
            dispatch({type: CREATE_ESTADOS_SUCCESS})
            dispatch(getEstados())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error(" Error creando Estado "+message)
                dispatch({type: CREATE_ESTADOS_ERROR})
        }
    } catch (error) {
        dispatch({type: CREATE_ESTADOS_ERROR})
    }
}

export const updateEstados = (id, obj)=>async(dispatch)=>{
    const {token} = store.getState().userReducer
    dispatch({type: UPDATE_ESTADOS_LOADING})
    try {
        const res = await axios(BASE_URL+"/estado/", {
            method: "patch",
            data: obj,
            headers: {
                Authorization: token,
                id: id
            }
        })
        const {status, message} = res.data
        if(status === 1)
        {
            toast.success(" Estado modificado correctamente. ")
            dispatch({type: UPDATE_ESTADOS_SUCCESS})
            dispatch(getEstados())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error("Error actualizando estado. "+message)        
            dispatch({type: UPDATE_ESTADOS_ERROR})
        }
    } catch (error) {
        toast.error("Error conexión. ")        
        dispatch({type: UPDATE_ESTADOS_ERROR})
    }
}

export const deleteEstados = (id)=>async(dispatch)=>{
    const {token} = store.getState().userReducer
    dispatch({type: DELETE_ESTADOS_LOADING})
    try {
        const res = await axios(BASE_URL+"/estado/", {
            method: "delete",
            headers: {
                Authorization: token,
                id: id
            }
        })
        const {status, message} = res.data
        if(status === 1)
        {
            dispatch({type: DELETE_ESTADOS_SUCCESS})
            dispatch(getEstados())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error(" Error borrando estado. "+message)
            dispatch({type: DELETE_ESTADOS_ERROR})
        }
    } catch (error) {
        dispatch({type: DELETE_ESTADOS_ERROR})
    }
}